import { getData } from './http';

const url = 'website/cms/';

export function getHotelInformation(estabId) {
    return getData(`${url}hotel?componentName=${estabId}`);
}

export function getUrlForPage(name) {
    return getData(`${url}geturlforpage?name=${encodeURIComponent(name)}`);
}
